export const loadEnv = async (customEnvFile) => {
  try {
    const importedRuntimeEnv = await import(
      /* @vite-ignore */ customEnvFile ?? './assets/environment.js'
    );
    const { env_vars } = importedRuntimeEnv;
    window._env_ = env_vars;
    Object.freeze(window._env_.vars);
  } catch {
    // Append error to url
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    console.error('Failed to load environment variables');
    url.searchParams.append('error', 'EnvLoadingFailed');
    window.history.pushState(null, '', url.toString());
  }
};
